import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { aosColor, IconSize, ModalWindowComponent } from '@ui/aos-lib';
import type { Observable } from 'rxjs';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ModalService } from 'src/app/services/utility/modal.service';
import { AboutService, type AboutVersions } from './about.service';

@Component({
  selector: 'aos-about-modal',
  imports: [AsyncPipe, NgOptimizedImage, ModalWindowComponent, TranslateModule],
  templateUrl: './about-modal.component.html',
  styleUrl: './about-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutModalComponent implements AfterViewInit {
  @ViewChild(ModalWindowComponent, { static: true }) modalWindowComponent!: ModalWindowComponent;

  readonly #modalService = inject(ModalService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #aboutService = inject(AboutService);

  protected readonly deviceGatewayLabel = TranslateRegistry.get.ABOUT.DEVICE_GATEWAY;
  protected readonly analyticsPlatformLabel = TranslateRegistry.get.ABOUT.ANALYTICS_PLATFORM;
  protected readonly releaseNotesText = TranslateRegistry.get.ABOUT.RELEASE_NOTES;
  protected readonly releaseNotesLink = 'https://aclara.my.site.com/AclaraConnect/s/';
  protected readonly linkColor = aosColor.primary500;
  protected readonly linkIconSize = IconSize.SM;
  protected versions$: Observable<AboutVersions> | null = null;

  ngAfterViewInit(): void {
    this.#modalService.register(this.modalWindowComponent, this.#destroyRef);
  }

  open(): void {
    this.versions$ = this.#aboutService.getVersions();
    const container = this.#modalService.containerRef();
    this.modalWindowComponent.open({ ...(container && { appendTo: container }) });
  }

  close(): void {
    this.modalWindowComponent.close();
  }
}
